import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewTotalCommentsComponent } from './review-total-comments.component';

@NgModule({
  declarations: [
    ReviewTotalCommentsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ReviewTotalCommentsComponent
  ]
})
export class ReviewTotalCommentsModule { }
